import {Controller} from "@hotwired/stimulus"
import TomSelect from "tom-select";
import {get} from "@rails/request.js";

// Connects to data-controller="tom-select--filter"
export default class extends Controller {
  static targets = ["filter", "other"]
  static values = {url: String}

  connect() {
    this.tomSelects = []
    this.refresh()

    var items = this.tomSelects[0].items
    this.filterTarget.addEventListener('change', ev => {
      if (this.selectedFilter)
        this.fetchItems()
      else
        this.clearItems()
    })

    if (this.selectedFilter && items.length === 0) this.fetchItems()
  }

  async refresh() {
    var config = {
      plugins: ['clear_button'],
      valueField: 'id',
      load: (q, callback) => this.search(q, callback)
    }


    for (const other of this.otherTargets) {
      if (!other.tomselect) {
        console.log("Create TOM SELECT")
        let tomSelect = new TomSelect(other, config);
        this.tomSelects.push(tomSelect)

        const response = await get(this.urlValue, {
          query: {filter: this.selectedFilter},
          responseKind: 'json'
        })

        tomSelect.addOptions(await response.json)

      }
    }
  }


  disconnect() {
    this.tomSelects.forEach(tomSelect => {
      tomSelect.destroy()
    })
  }

  async fetchItems() {
    const response = await get(this.urlValue, {
      query: {filter: this.selectedFilter},
      responseKind: 'json'
    })

    if (response.ok)
      this.setItems(await response.json)
    else
      console.log(response)
  }

  async search(q, callback) {
    const response = await get(this.urlValue, {
      query: {q: q, filter: this.selectedFilter},
      responseKind: 'json'
    })

    if (response.ok) {
      const list = await response.json
      callback(list)
    } else {
      console.log(response)
      callback()
    }
  }

  setItems(items) {
    this.clearItems()
    this.tomSelects.forEach(tomSelect => {
      tomSelect.addOptions(items)
    })
  }

  clearItems() {
    this.tomSelects.forEach(tomSelect => {
      tomSelect.clear()
      tomSelect.clearOptions()
    })
  }

  get selectedFilter() {
    return this.filterTarget.value
  }

  get preSelectedChild() {
    return this.data.get('pre-selected')
  }

}
